import { render } from "./Supplier_add.vue?vue&type=template&id=c1a37a80"
import script from "./Supplier_add.vue?vue&type=script&lang=js"
export * from "./Supplier_add.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__